import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
var debounce = require('throttle-debounce/debounce');

import FaqRow from './FaqRow';
import Ask from './Ask';

// var Collapse = require('rc-collapse');
import Collapse from 'rc-collapse';
var Panel = Collapse.Panel;

@inject('FaqStore', 'AuthenticationStore', 'ProductStore') @observer
export default class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordion: false,
      activeKey: [],
      activePopupAsk: false
    }

    this.dispatchSearch = debounce(300, this.dispatchSearch);
  }

  dispatchSearch(value) {
    const { FaqStore, AuthenticationStore } = this.props;
    FaqStore.search(value);
  }

  inputSearchChange(e) {
    this.dispatchSearch(e.target.value);
  }

  onChange(activeKey) {
    this.setState({ activeKey });
  }

  setActivityKey(key) {
    const activeKey = Array.isArray(key) ? key : [key];
    this.setState({ activeKey });
  }

  componentWillMount() {
    const { match: { params }, FaqStore } = this.props;
    if (params && params.faqId) {
      FaqStore.setFaqId(params.faqId);
      this.setActivityKey(params.faqId);
    }
  }

  render() {
    const { FaqStore, AuthenticationStore, ProductStore } = this.props;
    const category = ProductStore.sections && ProductStore.sections
      .find(section => section.id === FaqStore.selectedSection.id != 0);
    const items = category && category.products.map(({ id, name }) => ({ id, name }))
    return (
      <section id="content-faq" className="content">
        {!FaqStore.hasNoFaqs &&
          <div style={{ backgroundColor: "#e0e0e0" }}>
            <form className="filter-faq" onSubmit={e => e.preventDefault()}>
              <p>
                <input type="text" id="" name="" placeholder="Buscar..."
                  onChange={this.inputSearchChange.bind(this)} />

                <button className="icon">
                  <img src={require('../img/icon-search-gray.svg')} alt="" className="icon-normal" />
                </button>
              </p>
            </form>
            {items && (
              <div className="faq-filter">
                <ul>
                  <li>
                    <button className={!FaqStore.productId ? 'active' : ''} onClick={() => FaqStore.clearFilterProducts()} >Todas</button>
                  </li>
                  {items.map((item, key) => (
                    <li key={`category-${item.id}`}>
                      <button className={FaqStore.productId === item.id ? 'active' : ''} onClick={() => FaqStore.filterProducts(item.id)}>{item.name}</button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {FaqStore.faqs.length > 0 &&
              <div>
                <Collapse accordion={true} onChange={this.onChange.bind(this)} activeKey={this.state.activeKey}>
                  {FaqStore.faqs.map(faq => {
                    return (
                      <Panel key={faq.id} header={faq.question}>
                        <span className="container-dangerously-html" dangerouslySetInnerHTML={{
                          __html: faq.answer
                        }} />
                        {!AuthenticationStore.userCanAnswerQuestions &&
                          <FaqRow key={`faqRow${faq.id}`} faq={faq} setActivityKey={() => this.setActivityKey([])} />
                        }
                      </Panel>
                    )
                  })}
                </Collapse>
              </div>
            }

            {FaqStore.faqs.length == 0 &&
              <section className="content-results">
                <section className="no-results-box">
                  {FaqStore.searchTerm && FaqStore.searchTerm.length > 0 && (
                    <div>
                      <img src={require('../img/icon-no-result.svg')} alt="" />
                      <h1>Sua busca não obteve resultados!</h1>
                    </div>
                  )}
                  {!FaqStore.searchTerm && FaqStore.productId && (
                    <h1>Ainda não existem perguntas frequentes para este produto.</h1>
                  )}

                  {!AuthenticationStore.userCanAnswerQuestions &&
                    <button className={this.state.activePopupAsk ? 'disabled' : ''} onClick={() => this.setState({ activePopupAsk: true })}>Perguntar ao Gerente de Produto</button>
                  }
                </section>

                {this.state.activePopupAsk && <Ask />}
              </section>
            }
          </div>
        }

        {FaqStore.hasNoFaqs && <p className="no-results" style={{ padding: '33px 37px 42px' }}>Ainda não existem perguntas frequentes para este segmento.</p>}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Faq.js